import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const reportTemplateFields = {
  id: true,
  name: true,
  granularity: true,
  columns: true,
  filters: { sessionIds: true, groupIds: true, state: true, period: { kind: true, from: true, to: true } },
  schedule: { frequency: true, weekday: true, monthDay: true, hour: true, recipientIds: true, enabled: true, lastSentAt: true },
} as const

/** Les modèles de rapport de l'organisation (#163), triés par nom. */
export const GQL_REPORT_TEMPLATES = typedGql('query', { scalars })({
  reportTemplates: reportTemplateFields,
})

/** Les colonnes qu'une granularité peut porter, libellées dans les deux langues. */
export const GQL_REPORT_COLUMNS = typedGql('query', { scalars })({
  reportColumns: [{ granularity: $('granularity', 'ReportGranularity!') }, { key: true, level: true, label: { fr: true, en: true } }],
})

export const GQL_CREATE_REPORT_TEMPLATE = typedGql('mutation', { scalars })({
  createReportTemplate: [{ input: $('input', 'ReportTemplateInput!') }, reportTemplateFields],
})

export const GQL_UPDATE_REPORT_TEMPLATE = typedGql('mutation', { scalars })({
  updateReportTemplate: [{ id: $('id', 'ID!'), input: $('input', 'ReportTemplateInput!') }, reportTemplateFields],
})

export const GQL_DUPLICATE_REPORT_TEMPLATE = typedGql('mutation', { scalars })({
  duplicateReportTemplate: [{ id: $('id', 'ID!'), name: $('name', 'String') }, reportTemplateFields],
})

export const GQL_DELETE_REPORT_TEMPLATE = typedGql('mutation', { scalars })({
  deleteReportTemplate: [{ id: $('id', 'ID!') }, true],
})

/** Les comptes qu'un envoi peut viser : l'encadrement qui a le droit d'exporter (l'API en décide). */
export const GQL_REPORT_RECIPIENTS = typedGql('query', { scalars })({
  reportRecipients: { id: true, firstName: true, lastName: true, email: true },
})

/** Programme (ou reprogramme) l'envoi d'un modèle par mail. */
export const GQL_UPSERT_REPORT_SCHEDULE = typedGql('mutation', { scalars })({
  upsertReportSchedule: [{ templateId: $('templateId', 'ID!'), input: $('input', 'ReportScheduleInput!') }, reportTemplateFields],
})

export const GQL_DELETE_REPORT_SCHEDULE = typedGql('mutation', { scalars })({
  deleteReportSchedule: [{ templateId: $('templateId', 'ID!') }, reportTemplateFields],
})

export type ReportTemplate = InputType<GraphQLTypes['ReportTemplateModel'], typeof reportTemplateFields, typeof scalars>

export type ReportColumn = { key: string, level: string, label: { fr: string, en: string } }
